import {mapRecordToItems} from '@/helpers/mapRecordToItems.helper';

/** Fields of a cooperation fee contract (Kooperations-Honorar: the school pays us). Never grant to teachers. */
export enum CooperationFeeContractFields {
    INSTITUTION = 'institution',
    TITLE = 'title',
    COURSES = 'courses',
    RESPONSIBLE = 'responsible',
    COUNTERPARTY_NAME = 'counterpartyName',
    VERSIONS = 'versions',
    DOCUMENTS = 'documents',
    NOTE = 'note',
    CHANGE_LOG = 'changeLog',
    CREATED_AT = 'createdAt',
    UPDATED_AT = 'updatedAt',
}

export namespace CooperationFeeContractFields {
    type Data = {
        text: string;
        readOnly?: true;
        updateOnly?: true;
    }

    export const Record: Record<CooperationFeeContractFields, Data> = {
        [CooperationFeeContractFields.INSTITUTION]: {text: 'Standort', readOnly: true},
        [CooperationFeeContractFields.TITLE]: {text: 'Bezeichnung'},
        [CooperationFeeContractFields.COURSES]: {text: 'Kurse (leer = alle Kurse am Standort)'},
        [CooperationFeeContractFields.RESPONSIBLE]: {text: 'Zahlende Stelle (Verantwortliche:r)'},
        [CooperationFeeContractFields.COUNTERPARTY_NAME]: {text: 'Zahlende Stelle (Freitext)'},
        [CooperationFeeContractFields.VERSIONS]: {text: 'Versionen (Modell, Betrag, Gültigkeit, Pausen)'},
        [CooperationFeeContractFields.DOCUMENTS]: {text: 'Dokumente'},
        [CooperationFeeContractFields.NOTE]: {text: 'Notiz'},
        [CooperationFeeContractFields.CHANGE_LOG]: {text: 'Änderungsverlauf', readOnly: true},
        [CooperationFeeContractFields.CREATED_AT]: {text: 'Erzeugungsdatum', readOnly: true},
        [CooperationFeeContractFields.UPDATED_AT]: {text: 'Aktualisiert am', readOnly: true},
    };

    export const Items = mapRecordToItems(Record);
}
